export default function formatLead(input) {
  switch (input) {
    case 'noContact':
      return 'Chưa chăm sóc'
    case 'appointmentSet':
      return 'Đã chăm sóc'
    case 'productVerified':
      return 'Đã có kết quả'
    case 'succeed':
      return 'Đã cọc'
    case 'failed':
      return 'Thất bại'
    case 'status':
      return 'G.Đ chăm sóc'
    case 'touchPoint':
      return 'Điểm chạm'
    case 'phone':
      return 'Số điện thoại'
    case 'buyerName':
      return 'Tên người mua'
    case 'importOrigin':
      return 'Nguồn marketing'
    case 'activeCode':
      return 'Mã hồ sơ'
    case 'activeCodes':
      return 'Danh sách mã hồ sơ'
    case 'inCharge':
      return 'Người chịu trách nhiệm'
    case 'email':
      return 'Email'
    case 'product':
      return 'Hệ đào tạo'
    case 'products':
      return 'Danh sách hệ đào tạo'
    case 'undefined':
      return 'Chưa có'
    case 'imported':
      return 'Nhà trường tạo'
    case 'createdByParent':
      return 'Phụ huynh tạo'
    case 'parent':
      return 'Phụ huynh tạo'
    case 'intermediate':
      return 'Phổ thông'
    case 'advance':
      return 'Cao cấp'
    case 'cold':
      return 'Thấp'
    case 'warm':
      return 'Vừa'
    case 'hot':
      return 'Cao'
    case 'interest':
      return 'Mức độ quan tâm'
    case 'segment':
      return 'Phân khúc'
    default:
      return input
  }
}
